import React from 'react'
import { Card } from 'antd'
import ChooseScheme from './components/choose-scheme'

const ChooseSchemePage = ({ onChange }: { onChange: (qcType: number) => void }) => {
  return (
    <Card>
      <ChooseScheme onChange={(qcType) => {
        onChange(qcType)
      }} />
    </Card>
  )
}

export default ChooseSchemePage
